module.exports = __webpack_public_path__ + "je.svg?d85a7691c69fa1f67db78084efc855e0";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/je.svg
// module id = 1286
// module chunks = 27